'use client';

import {
	Box,
	Button,
	Stack,
	Text,
	useBreakpointValue,
} from '@chakra-ui/react';

import { NextImageWithSkeleton } from '@packages/chakra-v3';

type HomeHeroSectionProps = {
	image:       string;
	imageMobile: string;
	heading:     string;
	subheading:  string;
	cta:         string;
	onClickCta:  () => void;
};

const HomeHeroSection = ({
	image,
	imageMobile,
	heading,
	subheading,
	cta,
	onClickCta,
} : HomeHeroSectionProps) => {
	const heroImage = useBreakpointValue({
		base: imageMobile,
		md:   image,
	});

	return (
		<Box layerStyle={'white'} position={'relative'} w={'100%'}>
			<NextImageWithSkeleton
				alt={'heroImage'}
				aspectRatio={{
					base: 'portrait',
					md:   'wide',
				}}
				src={heroImage!}
				width={'100%'}
			/>
			<Stack
				gap={6}
				left={12}
				position={'absolute'}
				top={'50%'}
				transform={'translateY(-50%)'}
				w={{
					sm: '90%',
					md: '45%',
				}}
			>
				<Text
					as={'h2'}
					textStyle={{
						base: 'h3',
						md:   'h2',
					}}
					textTransform={'uppercase'}
				>
					{heading}
				</Text>
				<Text
					textStyle={{
						base: 'p2',
						md:   'p1',
					}}
					w={'min(50ch, 100%)'}
				>{subheading}
				</Text>
				<Button mt={6} w={'150px'} onClick={onClickCta}>{cta}</Button>
			</Stack>
		</Box>
	);
};

export default HomeHeroSection;